import cadastrarTemplo  from '../../../../Assets/help-page/cadastro_de_templo.mp4'
import chatAdmin  from '../../../../Assets/help-page/chat_admin.mp4'

export const CarouselData = [
  {
    video:
      cadastrarTemplo 
  },
  {
    video:
    chatAdmin
  },
];